module.exports = __webpack_public_path__ + "static/media/fireplace.bf8f608e.svg";